import { CreateWorkflowModal } from '@/components/WorkflowBuilder/CreateWorkflowModal';
import { WorkflowListPage } from '@/components/WorkflowBuilder/WorkflowListPage';
import { Button, Icons, LoadingIndicator } from '@commenda/kakashi';
import { AffiliateConsolePage } from 'components/Layouts/AffiliateConsolePage';
import { useState } from 'react';
import { useAffiliateWorkflows } from './useAffiliateWorkflows';

/** The real workflow builder on the affiliate console: the same list and editor the client app
 * uses, scoped to templates the signed-in user created. Rows open the real versions page and
 * editor. */
const AffiliateWorkflowsPageContent = () => {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const {
    workflows,
    error,
    mutate,
    getEditorHref,
    getWorkflowHref,
    isLoading,
    isUserMissing,
  } = useAffiliateWorkflows();

  if (isLoading) {
    return (
      <div className="flex min-h-0 flex-1 items-center justify-center">
        <LoadingIndicator />
      </div>
    );
  }

  if (error || isUserMissing) {
    return (
      <div className="flex min-h-0 flex-1 items-center justify-center">
        <span className="txt-small-regular text-text-tertiary">
          Couldn&apos;t load workflows. Refresh to try again.
        </span>
      </div>
    );
  }

  if (workflows.length === 0) {
    return (
      <div className="flex min-h-0 flex-1 flex-col items-center justify-center gap-xl px-xl">
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-bg-secondary">
          <Icons.GitBranch01
            aria-hidden="true"
            className="size-6 text-fg-brand"
          />
        </div>
        <div className="flex flex-col items-center gap-xs text-center">
          <h1 className="font-semibold text-2xl text-text-primary">
            No workflows yet
          </h1>
          <p className="txt-small-regular text-text-tertiary">
            Build a workflow once, assign it to clients, and run it for each of
            them.
          </p>
        </div>
        <Button size="md" onClick={() => setShowCreateModal(true)}>
          Create a workflow
        </Button>
        <CreateWorkflowModal
          isOpen={showCreateModal}
          onClose={() => setShowCreateModal(false)}
          getEditorHref={getEditorHref}
        />
      </div>
    );
  }

  return (
    <div className="min-h-0 flex-1 overflow-y-auto p-3xl">
      <WorkflowListPage
        workflows={workflows}
        mutate={mutate}
        getWorkflowHref={getWorkflowHref}
        getEditorHref={getEditorHref}
        showMetadataControls
      />
    </div>
  );
};

const AffiliateWorkflowsPage = () => (
  <AffiliateConsolePage>
    <AffiliateWorkflowsPageContent />
  </AffiliateConsolePage>
);

export default AffiliateWorkflowsPage;
